/*
 * Styles for <agwa-hover-card>: an inline anchor, and a card drawn in the top layer over it (see
 * agwa-hover-card.ts). The card's look is the host's own markup; this only makes the popover box
 * itself invisible, so what shows is exactly the host's card.
 *
 * Imported by agwa-hover-card.ts via `?inline` + `unsafeCSS`. It names no colour.
 */

:host {
  display: inline;
}

.anchor {
  display: inline;
}

/*
 * The browser's own popover box is centred in the window with a border, padding and a canvas
 * background; all of that is undone so the host's card is the only thing drawn, at the position
 * the component computes. Fixed, so an engine without the Popover API still draws it above the
 * page's flow, if not above every stacking context.
 */
.card {
  position: fixed;
  inset: auto;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  overflow: visible;
  width: max-content;
  display: none;
}
.card.shown {
  display: block;
}
